import { Card } from "@/components/ui/card";
import AuthLayout from "../auth-layout";
import { TOTPSetupForm } from "./components/totp-setup-form";

interface TOTPSetupProps {
  isSuperadmin: boolean;
}

export default function TOTPSetup({ isSuperadmin }: TOTPSetupProps) {
  return (
    <AuthLayout>
      <Card className="p-6">
        <div className="mb-2 flex flex-col space-y-2 text-left">
          <h1 className="text-md font-semibold tracking-tight">
            Set Up Two-Factor Authentication
          </h1>
          <p className="text-muted-foreground text-sm">
            Scan the QR code with your authenticator app and enter the code
            below.
          </p>
        </div>
        <TOTPSetupForm isSuperadmin={isSuperadmin} />
        <p className="text-muted-foreground mt-4 px-8 text-center text-sm">
          Use an authenticator app like Google Authenticator, Authy, or
          Microsoft Authenticator.
        </p>
      </Card>
    </AuthLayout>
  );
}
